import * as React from "react";
import { connect } from "react-redux";
import { ClaimProfileModal } from "../../modals/claim-profile-modal";
import { getNewUniqueId } from "@radivision/common";
import * as Actions from "../../../redux/actions";
import { AppState } from "../../../redux";
import { Router } from "../../../utilities/router";
import { GRAPHQL_TYPE_PERSON, GRAPHQL_TYPE_ENTITY, Person, Entity, ClaimRequest } from "@radivision/graphql";
import { MODAL_ID } from "./profile-header";
import { UserRequestType } from "@radivision/graphql/lib/ts/graphql/user-request-type";
import { AccountControl } from "../../modals/register-and-login/account-control";
import { Modal } from "../../modals/modal";
import { SVG } from "../../../component-configuration/svgs";
import {isOwner} from "../../../utilities/is-owner";

export const CLAIM_MODAL_ID = `claim${getNewUniqueId()}`;

interface ComponentProps {
  subject: Person | Entity;
  onChangeModalTitle: (s: string) => void;
}

interface MapDispatchProps {
  user: Person;
}

interface MapStateProps {}

export type Props = ComponentProps & MapDispatchProps & MapStateProps;

export const Component = (props: Props) => {
  const { user, subject, onChangeModalTitle } = props;
  const isPerson = subject?.__typename === GRAPHQL_TYPE_PERSON;
  const isCompany = subject?.__typename === GRAPHQL_TYPE_ENTITY;
  const owner = isOwner(subject,user);

  // const showMoreMenu = !owner && ((isPerson && !user) || isCompany) && subject?.isClaimable;
  // if (!showMoreMenu) {
  //   return null;
  // }
  return (
    <>
      {subject && !owner ? (
        <div id="claim-modal-container">
          <AccountControl
            activeModal={ClaimProfileModal}
            modalId={CLAIM_MODAL_ID}
            modalProps={{
              email: user
                ? user.emailAddresses === null || user.emailAddresses === undefined
                  ? null
                  : user.emailAddresses[0]
                : "",
              profileId: subject?.id,
              profileName: isCompany ? subject?.name : subject?.fullName,
              title: `Claim ${isPerson ? "Personal Profile" : "Company Page"}`,
              type: isPerson ? "person" : "entity",
              userId: user ? user?.id : "",
              username: user ? user.fullName : "",
            }}
          />
        </div>
      ) : null}

      <Modal id="avoidMultipleClaim" title="">
        <div className="message-modal text-center">
          <h2>Pending Review!</h2>
          <p className="message">
            <span>
              Your request is submitted successfully , We will review your submission and be back
              in touch soon!
            </span>
          </p>
        </div>
      </Modal>
    </>
  );
};

const mapState = (state: AppState) => ({
  user: state.account.user,
});

const mapDispatch = {
  createPostSet: Actions.createPostSet,
};

export const ClaimDropMenuModal = connect(mapState, mapDispatch)(Component);
